import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import { getBases, addBase, updateBase } from "../api/baseApi";
import { showError } from "../utils/alert";

const initialForm = {
  airport_code: "",
  airport_name: "",
  city: "",
  country: "",
};

export default function BaseForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(id);
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isEdit) {
      loadBase();
    }
  }, [id]);

  const loadBase = async () => {
    try {
      const res = await getBases({ page: 1, per_page: 1000 });
      const items = Array.isArray(res.data?.items) ? res.data.items : (res.data || []);
      const base = items.find((b) => b.id === parseInt(id, 10));
      if (base) {
        setForm({
          airport_code: base.airport_code || "",
          airport_name: base.airport_name || "",
          city: base.city || "",
          country: base.country || "",
        });
      } else {
        showError("Base not found");
        navigate("/bases");
      }
    } catch (err) {
      showError("Failed to load base");
      navigate("/bases");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.airport_code.trim()) {
      return showError("Airport code is required");
    }

    setLoading(true);
    try {
      const payload = {
        ...form,
        airport_code: form.airport_code.trim().toUpperCase(),
      };
      if (isEdit) {
        await updateBase(id, payload);
      } else {
        await addBase(payload);
      }
      navigate("/bases");
    } catch (err) {
      showError(isEdit ? "Failed to update base" : "Failed to add base");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout title={isEdit ? "Edit Base" : "Add Base"}>
      <div className="card shadow-sm">
        <div className="card-body">
          <h5 className="card-title mb-3">
            {isEdit ? "Edit Base" : "Add New Base"}
          </h5>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Airport code *</label>
              <input
                name="airport_code"
                className="form-control"
                value={form.airport_code}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Airport name</label>
              <input
                name="airport_name"
                className="form-control"
                value={form.airport_name}
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">City</label>
              <input
                name="city"
                className="form-control"
                value={form.city}
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Country</label>
              <input
                name="country"
                className="form-control"
                value={form.country}
                onChange={handleChange}
              />
            </div>
            <div className="d-flex gap-2">
              <button
                type="submit"
                className="btn skedq-accent-btn"
                disabled={loading}
              >
                {loading ? "Saving..." : isEdit ? "Update" : "Add"}
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => navigate("/bases")}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </AdminLayout>
  );
}

